module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/name/prefix.js
 ** module id = 275
 ** module chunks = 0
 **/